import { ExpandableTable } from '@thinknet-gmbh/platform-common-ui';
import styled from 'styled-components';

export const DatevWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 20px;
  & > div:last-child {
    width: 100%;
  }
`;

export const SettingContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
  justify-content: space-between;
  align-items: start;
  height: 100%;
`;

export const ExpandableStyledTable = styled(ExpandableTable)`
  .ant-table-content .ant-table-tbody {
    .ant-table-expanded-row td > div {
      padding: 0;
    }
    .ant-table-row td > div {
      padding: 9px 12px;
    }
  }
`;
